// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"75d52e46","378":"937133f5","416":"b4862bf3","467":"c6700937","657":"a723f2ec","693":"5f630caa","737":"64384695"}[chunkId] + ".chunk.js";
};